"use client";

function Skills() {
  return (
    <main>
      <section id="education" className="">
          <div className="pt-16 text-black dark:text-white transition-colors duration-1000">
          <h1 className='flex justify-center text-3xl font-bold text-black dark:text-white transition-colors duration-1000'>Education</h1>
          <div className='py-5 flex gap-5 flex-wrap'>

          <div className="card card-compact w-full bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000">
              <div className="card-body text-zinc-900 dark:text-white transition-colors duration-1000">
                  <h2 className="card-title">University of California, San Diego</h2>
                  <i className="-mt-3">B.S. in Computer Science, Business Minor</i>
                  <section>
                    <h3 className="text-md font-semibold">Computer Science Relevant Coursework:</h3>
                  {("Operating Systems, Advanced DS, Software Engineering, Computer Architecture, AI: Search & Reasoning, ML: Learning Algorithms, Statistical NLP, Entrepreneurship for Engineers, Web Client Languages").split(', ').map((str) => (
                    <p className="m-1 bg-zinc-300 dark:bg-zinc-700 p-1 inline-block">{str}</p>
                  ))}
                  </section>
                  <section>
                    <h3 className="text-md font-semibold">Business Relevant Coursework:</h3>
                  {("Principles of Accounting, Product Marketing & Management, Operations Management, Enterprise Finance, Global Business Strategy, Negotiations").split(', ').map((str) => (
                    <p className="m-1 bg-zinc-300 dark:bg-zinc-700 p-1 inline-block">{str}</p>
                  ))}
                  </section>
                  <div className="card-actions justify-end">
                      <p>Graduation: March 2026</p>  
                </div>
              </div>
            </div>

          </div>
          </div>
        </section>
      <section id="experience" className="">
          <div className="pt-16 text-black dark:text-white transition-colors duration-1000">
          <h1 className='flex justify-center text-3xl font-bold text-black dark:text-white transition-colors duration-1000'>Work Experience</h1>
          <div className='py-5 flex gap-5 flex-wrap'>

          <div className="card card-compact w-full bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000">
              <div className="card-body text-zinc-900 dark:text-white transition-colors duration-1000">
                  <h2 className="card-title">Amazon</h2>
                  <i className="-mt-3">Software Development Engineer Intern</i>
                  <section>
                    <p className="m-1 bg-zinc-300 dark:bg-zinc-700 p-1 inline-block">Designed and authored an approved design doc for scalable workflows to restore invalid producer-consumer subscriptions and clean up old subscriptions, which integrated 4 production-grade APIs that ensured modularity and reusability</p>
                    <p className="m-1 bg-zinc-300 dark:bg-zinc-700 p-1 inline-block">Implemented invalid subscription recovery workflow that leveraged parallel child workflows (concurrently processing 5 subscriptions) with exponential backoff retry and failure handling, improving a prior design that processed one by one</p>
                    <p className="m-1 bg-zinc-300 dark:bg-zinc-700 p-1 inline-block">Developed a recurring cleanup mechanism to identify and delete old subscriptions by using subscription usage events, improving data hygiene and reducing query/storage overhead across 750k subscriptions (~16% identified as inactive)</p>
                  </section>
                  <div className="card-actions justify-between">
                    <div className='gap-3 flex flex-wrap'>
                      <div className="badge badge-outline text-zinc-900 dark:text-white transition-colors duration-1000">Kotlin</div> 
                      <div className="badge badge-outline text-zinc-900 dark:text-white transition-colors duration-1000">PDL</div>
                      <div className="badge badge-outline text-zinc-900 dark:text-white transition-colors duration-1000">API</div>
                      <div className="badge badge-outline text-zinc-900 dark:text-white transition-colors duration-1000">Software Architectural Design</div>
                      <div className="badge badge-outline text-zinc-900 dark:text-white transition-colors duration-1000">Workflows</div>
                    </div>  
                    <p className="flex-grow-0">June 2025 - September 2025</p>      
                </div>
              </div>
            </div>

          <div className="card card-compact w-full bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000">
              <div className="card-body text-zinc-900 dark:text-white transition-colors duration-1000">
                  <h2 className="card-title">Vetscribe by Rito Labs</h2>
                  <i className="-mt-3">Software Engineering Intern</i>
                  <section>
                    <p className="m-1 bg-zinc-300 dark:bg-zinc-700 p-1 inline-block">Developed a full-stack web and mobile application using AWS Amplify (GraphQL API), Expo, and React, contributing core features for veterinarians to generate AI-powered visit summaries and forms.</p>
                    <p className="m-1 bg-zinc-300 dark:bg-zinc-700 p-1 inline-block">Designed and implemented an interactive live recording waveform and real-time toast notifications, enabling veterinarians to identify errors and review transcriptions more efficiently.</p>
                    <p className="m-1 bg-zinc-300 dark:bg-zinc-700 p-1 inline-block">Built AWS Lambda functions (e.g., Duplicate Template, Recursive Delete Section/Subsection), streamlining template management and reducing editing steps by over 80%.</p>
                  </section>
                  <div className="card-actions justify-between">
                    <div className='gap-3 flex flex-wrap'>
                      <div className="badge badge-outline text-zinc-900 dark:text-white transition-colors duration-1000">Expo</div> 
                      <div className="badge badge-outline text-zinc-900 dark:text-white transition-colors duration-1000">AWS Amplify</div>
                      <div className="badge badge-outline text-zinc-900 dark:text-white transition-colors duration-1000">React Native</div>
                      <div className="badge badge-outline text-zinc-900 dark:text-white transition-colors duration-1000">GraphQL</div>  
                    </div>  
                    <p className="flex-grow-0">July 2024 - March 2025</p>      
                </div>
              </div>
            </div>

            <div className="card card-compact w-full bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000">
              <div className="card-body text-zinc-900 dark:text-white transition-colors duration-1000">
                  <h2 className="card-title">System Energy Efficiency (SEE) Lab UC San Diego</h2>
                  <i className="-mt-3">Student Research Assistant</i>
                  <section>
                    <p className="m-1 bg-zinc-300 dark:bg-zinc-700 p-1 inline-block">Improved hyperdimensional computing mass spectrometry data clustering tool, HyperSpec, by expanding support for multiple input file types, increasing compatibility and usability.</p>
                    <p className="m-1 bg-zinc-300 dark:bg-zinc-700 p-1 inline-block">Installed and ran mass spectrometry clustering tools like ANN-SoLo on CUDA-1 and CUDA-2 servers and collected data on speed and accuracy.</p>
                  </section>
                  <div className="card-actions justify-between">
                    <div className='gap-3 flex flex-wrap'>
                      <div className="badge badge-outline text-zinc-900 dark:text-white transition-colors duration-1000">Docker</div> 
                      <div className="badge badge-outline text-zinc-900 dark:text-white transition-colors duration-1000">Hyperdimensional Computing</div>
                    </div>  
                    <p className="flex-grow-0">May 2024 - Dec 2024</p>       
                </div>
              </div>
            </div>

            

          </div>
          </div>
        </section>

      <section className="min-h-screen">
        <div className="pt-16 text-black dark:text-white transition-colors duration-1000">
          <h1 id="skills" className="flex justify-center text-3xl font-bold mb-2">Technical Skills</h1>
          {/* <div className="flex gap-3">(
            <span className="indicator-item badge bg-pink-500 text-black font-semibold">recently used</span> 
            <span className="indicator-item badge bg-sky-400 text-black font-semibold">learning</span> 
            )
          </div> */}
          <section>
            <h2 className="text-2xl font-semibold">Languages</h2>
            <div className="p-2 gap-2 flex flex-wrap">
              {[
                'Java',
                'Python',
                'C',
                'C++',
                'C#',
                'Bash',
                'HTML/CSS',
                'JavaScript',
                'Kotlin',
                'Assembly (ARM, MIPS)',
              ].map((item) => (
                <div
                  key={item}
                  className="p-2 px-3 rounded-lg bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000"
                >
                  <h2 className="text-sm text-zinc-900 dark:text-white transition-colors duration-1000">
                    {item}
                  </h2>
                </div>
              ))}
            </div>
          </section>
          <section>
            <h2 className="text-2xl font-semibold">Tools</h2>
            <div className="p-2 gap-2 flex flex-wrap">
              {[
                'AWS (Cloudwatch, CloudFormation, DynamoDB, ECS, Amplify, Lambda)',
                'Git',
                'Generative AI',
                'Firebase',
                'Figma',
                'Unity',
              ].map((item) => (
                <div
                  key={item}
                  className="p-2 px-3 rounded-lg bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000"
                >
                  <h2 className="text-sm text-zinc-900 dark:text-white transition-colors duration-1000">
                    {item}
                  </h2>
                </div>
              ))}
            </div>
          </section>
          <section>
            <h2 className="text-2xl font-semibold">Frameworks & Libraries</h2>
            <div className="p-2 gap-2 flex flex-wrap">
              {[
                'React',
                'Flask/Quart',
                'TailwindCSS',
                'Expo',
                'Unity',
                'Pandas',
                'scikit-learn',
              ].map((item) => (
                <div
                  key={item}
                  className="p-2 px-3 rounded-lg bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000"
                >
                  <h2 className="text-sm text-zinc-900 dark:text-white transition-colors duration-1000">
                    {item}
                  </h2>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">Techniques</h2>
            <div className="p-2 gap-2 flex flex-wrap">
              {[
                'Software architectural design',
                'Agile software process',
                'Unit testing',
                'Object mocking',
              ].map((item) => (
                <div
                  key={item}
                  className="p-2 px-3 rounded-lg bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000"
                >
                  <h2 className="text-sm text-zinc-900 dark:text-white transition-colors duration-1000">
                    {item}
                  </h2>
                </div>
              ))}
            </div>
          </section>
          
          
          

        </div>
      </section>
    </main>
  )
}

export default Skills